(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formGeneralContact', [function() {
      return {
        restrict: "E",
        scope: {},
        bindToController: true,
        controllerAs: 'vm',
        templateUrl: '/general-contact/partials/contact-form',
        link: function() {},
        controller: [
          'FormService',
          'DeviceService',
          '$timeout',
          '$window',
          'AnalyticsService',
          function(
            FormService,
            DeviceService,
            $timeout,
            $window,
            AnalyticsService
          ) {

            var self = this,
              prefillMode = false,
              prefillData = FormService.prefillForm(prefillMode, 'generalContact');

            self.formData    = prefillData.formData;
            self.formResult  = prefillData.formResult;

            self.regions = FormService.getRegionsForSelect();

            self.analyticsConfig = {
              googleAnalytics: {
                pageViewUrl: '/ajax-goals/general-contact'
              }
            };

            self.checkFormValidation = function(form) {
              self.triedSubmit = true;

              if (! form.$valid) {
                return;
              }

              processGetInTouchForm();
            };

            function processGetInTouchForm() {
              self.formResult.showForm = false;
              self.formResult.showLoader = true;

              prepareFormData();


              FormService.submit('/forms/general-inquiry', self.formData)
                .then(function(result) {
                  self.formResult = result;

                  AnalyticsService.logTrackingClick(self.analyticsConfig);

                  return result;
                });
            }

            function prepareFormData() {
              self.formData.selected_regions = [self.formData.selected_regions];
            }

          }]
      };
    }]);
})();